// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../../node_modules/postcss-loader/src/index.js!../../../../node_modules/sass-loader/dist/cjs.js!@css/utils");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
exports.push([module.id, ".jOEsi9mux{}._4ByAhCJhx{width:100%}._5dMbkbdVx{margin:0 12px 0 16px}._7I04kknbx{display:flex;flex-direction:column;width:100%;max-width:calc(100vw - 149px)}._5aEHNdZrx{background-color:rgba(0,0,0,0.1);width:40px;height:40px;border-radius:100%}._4VxUkPNYx{background-color:rgba(0,0,0,0.1);height:18px;width:200px;margin-top:5px}._6WkNQfv8x{background-color:rgba(0,0,0,0.05);height:14px;width:200px;margin-top:5px}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"skeleton": "jOEsi9mux " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["skeleton-pulse"] + "",
	"container": "_4ByAhCJhx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["vertically-center"] + "",
	"icon-container": "_5dMbkbdVx",
	"iconContainer": "_5dMbkbdVx",
	"info-container": "_7I04kknbx",
	"infoContainer": "_7I04kknbx",
	"app-icon-skeleton": "_5aEHNdZrx jOEsi9mux " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["skeleton-pulse"] + "",
	"appIconSkeleton": "_5aEHNdZrx jOEsi9mux " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["skeleton-pulse"] + "",
	"display-name-skeleton": "_4VxUkPNYx jOEsi9mux " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["skeleton-pulse"] + "",
	"displayNameSkeleton": "_4VxUkPNYx jOEsi9mux " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["skeleton-pulse"] + "",
	"subtitle-skeleton": "_6WkNQfv8x jOEsi9mux " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["skeleton-pulse"] + "",
	"subtitleSkeleton": "_6WkNQfv8x jOEsi9mux " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["skeleton-pulse"] + ""
};
module.exports = exports;
